import api from '@/utils/api'

export default {
    getTeams(page, size) {
        let range = '?range=' + encodeURIComponent(`[${page - 1},${size}]`)
        return api.get(`teams` + (page ? range : ''))
    },

    getFilteredTeams(filters, page, size, sortingOptions) {
        let query = (filters ? filters + '&range=' : '?range=') + encodeURIComponent(`[${page - 1},${size}]`)
        if (sortingOptions && sortingOptions.sortBy) {
            query += `&sort=${encodeURIComponent(`[${sortingOptions.sortBy}, ${sortingOptions.sortDesc}]`)}`
        }
        return api.get(`teams` + query)
    },
    getTeam(id) {
        return api.get(`teams/${id}`)
    },

    updateTeam(id, data) {
        return api.put(`teams/${id}`, data)
    },

    createTeam(data) {
        return api.post('teams', data)
    },

    uploadFile(formData) {
        return api.uploadFile('uploads/team', formData)
    },

    deleteTeam(id) {
        return api.delete(`teams/${id}`)
    },

    uploadTeamsCSV(formData) {
        return api.uploadFile('teams/import', formData)
    },

    downloadTeamsCSV(filters) {
        if (!filters) {
            filters = ''
        }
        return api.get(`teams/export` + filters)
    }
}
